import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarInlineCodeIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        className="Icon toolbar-inline-code"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} rx={4} />
            <path
                fill="#48505E"
                d="m16.772 9.818-3 12a.75.75 0 0 0 1.456.364l3-12a.75.75 0 0 0-1.456-.364zM11.53 13.53a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06-1.06L9.06 16l2.47-2.47zm8.94 0a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06-1.06L22.94 16l-2.47-2.47z"
            />
        </g>
    </svg>
);
const Memo = memo(ToolbarInlineCodeIcon);
export default Memo;
